export default "__VITE_ASSET__DRXM4aWu__"